<template>
  <v-container class="edit-gate-page" fluid>
    <v-breadcrumbs :items="breadcrumbs" class="px-0 pt-0 pb-2" />
    <div class="edit-gate-header">
      <h1 class="edit-gate-header__title">Редактирование калитки</h1>
      <v-btn
        color="primary"
        outlined
        class="edit-gate-header__btn text-none"
        dark
        rounded
        @click.prevent="returnGate()"
      >
        <v-icon left>mdi-eye-outline</v-icon>
        Просмотр информации
      </v-btn>
    </div>

    <div v-if="Object.keys(gateEdit).length !== 0" class="edit-gate-tabs-wrap mt-3">
      <v-tabs v-model="activeTab" class="edit-gate-tabs" grow show-arrows="mobile">
        <v-tab
          v-for="tab in visibleTabs"
          :key="tab.route"
          class="edit-gate-tab"
        >
          {{ tab.name }}
        </v-tab>
      </v-tabs>
    </div>

    <v-tabs-items v-if="Object.keys(gateEdit).length !== 0" v-model="activeTab" class="edit-gate-tabs-items">
      <v-tab-item
        v-for="tab in visibleTabs"
        :key="tab.route"
      >
        <v-card v-if="isDisplayInfoGate" class="edit-gate-block mt-0" flat outlined>
          <div class="edit-gate-tab-content pa-4">
            <component
              :is="tab.component"
              :returnGate="() => returnGate()"
            />
          </div>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import GeneralInfo from './components/GeneralInfo.vue';

export default {
  name: 'EditGate',
  props: ['id'],
  data () {
    return {
      activeTab: 0,
      isDisplayInfoGate: false,
      breadcrumbs: [
        { text: 'Калитки', disabled: false, href: '/gates' },
        { text: 'Редактирование', disabled: true, href: 'breadcrumbs_link_1' },
      ],
    };
  },
  created () {
    this.isDisplayInfoGate = false;
    this.getGateInfoEdit({ id: this.id })
      .then(() => {
        this.isDisplayInfoGate = true;
      })
      .catch(() => {
        this.$flash_warning('Ошибка при загрузке информации');
      });
  },
  computed: {
    ...mapGetters({
      gateEdit: 'Gate/gateEdit',
    }),
    tabs () {
      return [
        {
          name: 'Информация',
          component: GeneralInfo,
          route: 'EditGateGeneralInfoTab',
          show: true,
        },
      ];
    },
    visibleTabs () {
      return this.tabs.filter(tab => tab.show && this.$canRoute(tab.route));
    },
  },
  methods: {
    ...mapActions({
      getGateInfoEdit: 'Gate/getGateInfoEdit',
    }),
    returnGates () {
      this.$router.push({ name: 'Gates' });
    },
    returnGate () {
      this.$router.push({ name: 'DetailGate', params: { id: this.$route.params.id } });
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-gate-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 8px 0;
}

.edit-gate-header__title {
  font-size: 1.5rem;
  font-weight: 400;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.02em;
}

.edit-gate-header__btn {
  text-transform: none;
  font-weight: 500;
}

.edit-gate-tabs-wrap {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 12px 12px 0 0;
  border-bottom: none;
  overflow: hidden;
}

.edit-gate-tabs {
  box-shadow: none;
}

.edit-gate-tabs ::v-deep .v-tabs-bar {
  background: transparent;
  height: 48px;
}

.edit-gate-tabs ::v-deep .v-tab {
  text-transform: none;
  font-size: 0.9375rem;
  font-weight: 500;
  color: #546e7a;
  min-height: 48px;
}

.edit-gate-tabs ::v-deep .v-tab--active {
  color: #1976d2;
}

.edit-gate-tabs ::v-deep .v-tabs-slider {
  color: #1976d2;
  height: 3px;
}

.edit-gate-tabs ::v-deep .v-tabs-bar__prev,
.edit-gate-tabs ::v-deep .v-tabs-bar__next {
  flex: 0 0 auto;
  min-width: 44px;
}

.edit-gate-tabs-items {
  background: transparent;
}

.edit-gate-block {
  border-radius: 0 0 12px 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-top: none;
}

.edit-gate-tab-content {
  min-height: 200px;
}

@media screen and (max-width: 600px) {
  .edit-gate-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .edit-gate-header__title {
    font-size: 1.4rem;
  }
}
</style>
